import PropTypes from "prop-types";
import React from "react";

class WsOnlineStatus extends React.PureComponent {
  static get propTypes() {
    return {
      online: PropTypes.bool,
    };
  }

  renderOnline() {
    return (
      <div title="You are online and connected.">
        <i className="fa fa-signal ws-online" aria-hidden="true" />
        {" Online"}
      </div>
    );
  }

  renderOffline() {
    return (
      <div title="We are attempting to reconnect to the server.">
        <i className="fa fa-refresh spin ws-offline" aria-hidden="true" />
        {" Offline"}
      </div>
    );
  }

  render() {
    const { online } = this.props;

    return (
      <div className="ws-status-widget">
        {online ? this.renderOnline() : this.renderOffline()}
      </div>
    );
  }
}

export { WsOnlineStatus };
